import { render, staticRenderFns } from "./DrawDesign.vue?vue&type=template&id=494cc990&scoped=true&"
import script from "./DrawDesign.vue?vue&type=script&lang=js&"
export * from "./DrawDesign.vue?vue&type=script&lang=js&"
import style0 from "./DrawDesign.vue?vue&type=style&index=0&id=494cc990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494cc990",
  null
  
)

export default component.exports